import { Injectable } from '@angular/core';
import { Response } from "@angular/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient } from "../httpclient";
import { History } from "./history/history.model";

@Injectable()
export class AssetsService {

    private assetsPath = '/assets-service/';

    constructor(private httpClient: HttpClient) { }

    getLocations(pType : string): Observable<any> {
        
        let queryParams = '';
        if (pType != null) {
            queryParams = '?type=' + pType ;
        }
        
        return this.httpClient.get(this.assetsPath + 'locations' + queryParams ).pipe(map(this.extractData));
    }
    
    getStatus(): Observable<any[]> {
        return this.httpClient.get(this.assetsPath + 'status').pipe(map(this.extractData));
    }
    
    getMaterials(): Observable<any[]> {
        return this.httpClient.get(this.assetsPath + 'materials').pipe(map(this.extractData));
    }
    
    getContainers(): Observable<any[]> {
        return this.httpClient.get(this.assetsPath + 'containers').pipe(map(this.extractData));
    }
    
    getAssets(searchCriteria : any) : Observable<any[]> {
        return this.httpClient.post(this.assetsPath + 'stock/detailed', searchCriteria).pipe(map(this.extractData));     
    }
    
    getSumarized(searchCriteria : any) : Observable<any[]> {
        return this.httpClient.post(this.assetsPath + 'stock/summarized', searchCriteria).pipe(map(this.extractData));     
    }
        
    getAssetsNotAllocated(searchCriteria : any) : Observable<any[]> {
        return this.httpClient.post(this.assetsPath + 'stock/pending', searchCriteria).pipe(map(this.extractData));     
    }
    
    getHistory(serialNumber : string, page: number, size : number) : Observable<Array<History>> {
       return this.httpClient.get(this.assetsPath + 'assets/' + serialNumber + '/history?page=' + page.toString() + '&size=' + size.toString()).pipe(map(this.extractData));
    }
    
    getMovements(searchCriteria : any) : Observable<any[]> {
       return this.httpClient.post(this.assetsPath + 'movements/filtered', searchCriteria).pipe(map(this.extractData));   
    }
    
    getAssetsMovements(batchId : number) : Observable<any[]> {
       return this.httpClient.get(this.assetsPath + 'movements/' + batchId).pipe(map(this.extractData));   
    }
    
    getMovementTypes() : Observable<any[]> {
        return this.httpClient.get(this.assetsPath + 'movements/types').pipe(map(this.extractData));
    }
    
     private extractData(res: Response) {
        let body = res.json();
        return body;
    }

}